export default __webpack_public_path__ + "static/media/orangeSmall.ded6cf68.svg";